export function useModal() {
  const handleModalClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return {handleModalClick};
}
